import { DisclosureMonth, DisclosurePeriod } from '@/types';

// Bridge between village's wire shape (`DisclosureMonth` as English
// month name) and bungle `MonthPicker` (JS `Date` with month index
// 0–11). Kept narrow so `disclosure-header` doesn't need to know the
// string-list literal in two places.

const months: DisclosureMonth[] = [
  'january',
  'february',
  'march',
  'april',
  'may',
  'june',
  'july',
  'august',
  'september',
  'october',
  'november',
  'december',
];

const disclosureMonthIndex = (month: DisclosureMonth): number =>
  months.indexOf(month);

const disclosureMonthFromIndex = (index: number): DisclosureMonth => {
  const month = months[index];
  if (!month) {
    throw new Error(`invalid month index: ${index}`);
  }
  return month;
};

const renderDisclosureMonth = (month: DisclosureMonth): string =>
  month.charAt(0).toUpperCase() + month.slice(1);

// `period.month` is the *end* month; the disclosure resolves to a
// 12-month window ending then. Mirrors suit's
// `configuration-item-annual-period.renderYearMonth` for `mode='annual'`.
// {year=2025, month='june'} → "July 2024 to June 2025"
// {year=2025, month='december'} → "January 2025 to December 2025"
const renderDisclosurePeriod = (period: DisclosurePeriod): string => {
  const endIndex = disclosureMonthIndex(period.month);
  const startIndex = (endIndex + 1) % 12;
  const startYear = endIndex === 11 ? period.year : period.year - 1;
  const start = `${renderDisclosureMonth(disclosureMonthFromIndex(startIndex))} ${startYear}`;
  const end = `${renderDisclosureMonth(period.month)} ${period.year}`;
  return `${start} to ${end}`;
};

export {
  disclosureMonthIndex,
  disclosureMonthFromIndex,
  renderDisclosureMonth,
  renderDisclosurePeriod,
};
